import { memo } from 'react';

export type OnboardingIntroSkyWashProps = {
  'data-testid'?: string;
};

/** Layered night sky: 6px backdrop blur, altitude-4 at 92%, altitude-9 at 12%. */
export const OnboardingIntroSkyWash = memo(({ 'data-testid': dataTestId }: OnboardingIntroSkyWashProps) => (
  <div aria-hidden className="pointer-events-none absolute inset-0 z-0" data-testid={dataTestId} data-theme="dark">
    <div className="absolute inset-0 backdrop-blur-[6px]" />
    <div className="absolute inset-0 ads:bg-ads-altitude-4 bg-altitude-4 opacity-[0.92]" />
    <div className="absolute inset-0 ads:bg-ads-altitude-9 bg-altitude-9 opacity-[0.12]" />
  </div>
));

OnboardingIntroSkyWash.displayName = 'OnboardingIntroSkyWash';
